<template>
    <div class="table-container">
        <div class="header">
            <div class="title">Errors</div>
            <fieldset class="filters">
                <legend>Filters</legend>
                <v-container>
                    <v-row>
                        <v-col>
                            <div style="position: relative;">
                                <label
                                    class=""
                                >
                                    Date Range
                                </label>
                                <date-picker
                                    v-model="filterDateRange"
                                    range
                                    type="datetime"
                                    :input-attr="{ id: 'sent-date-picker' }"
                                    @clear="clearDateRange"
                                    @input="setDateRange"
                                />
                            </div>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="filters.campaignId"
                                background-color="white"
                                :disabled="isCampaignIdDisabled"
                                label="Campaign
                            Id"
                            />
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="filters.campaignName"
                                background-color="white"
                                :disabled="isCampaignIdDisabled"
                                label="Campaign Name"
                            />
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                v-model="filters.type"
                                background-color="white"
                                :items="typeOptions"
                                label="Type"
                            />
                        </v-col>
                        <v-col>
                            <v-select
                                v-model="filters.channel"
                                background-color="white"
                                :items="channelOptions"
                                label="Channel"
                            />
                        </v-col>

                    </v-row>
                </v-container>
                <v-col>
                    <button-search
                        :disabled="isFetchingTrans"
                        :callback="searchClick"
                    />
                    <v-btn
                        color="#d2042d"
                        style="color: #fff;"
                        class="mt-2"
                        @click="clearFilters"
                    >
                        Clear Filters
                    </v-btn>
                </v-col>
            </fieldset>
        </div>
        <array-view
            :items="items"
            :headers="commonHeaders"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :total-items="totalItems"
            :show-icons="false"
            :page-size-options="pageSizeOptions"
            :is-fetching="isFetchingTrans"
            @paginationChange="paginationChange"
        />
    </div>
</template>

<script>
    import 'vue2-datepicker/index.css'

    import ArrayView from '@/components/ArrayView.vue'
    import errorService from '@/services/error-service'
    import { MESSAGE_TYPES } from '@/utils/consts'
    import dateTimeUtils from '@/utils/date-time-utils'
    import DatePicker from 'vue2-datepicker'
    import ButtonSearch from '@/components/ButtonSearch.vue'

    export default {
        components: { ButtonSearch, ArrayView, DatePicker },
        data() {
            return {
                items: [],
                commonHeaders: [],
                totalPages: 0,
                page: 1,
                size: 15,
                totalItems: 0,
                filters: {
                    campaignId: '',
                    campaignName: '',
                    type: null,
                    channel: null,
                    timestampStart: null,
                    timestampEnd: null
                },
                typeOptions: [{
                    text: 'ALL',
                    value: null
                }, ...MESSAGE_TYPES.map(type => ({
                    text: type,
                    value: type
                }))],
                channelOptions: [{
                    text: 'ALL',
                    value: null
                }, {
                    text: 'SMS',
                    value: 'SMS'
                }, {
                    text: 'VIBER',
                    value: 'VIBER'
                }],
                filterDateRange: [],
                pageSizeOptions: [15, 50, 100],
                isFetchingTrans: false
            }
        },
        computed: {
            isCampaignIdDisabled() {
                return this.filters?.type === 'TRANSACTIONAL'
            },
            filtersToApply() {
                const filters = {}
                if (this.filters.campaignId) {
                    filters.campaignId = this.filters.campaignId
                }
                if (this.filters.campaignName) {
                    filters.campaignName = this.filters.campaignName
                }
                if (this.filters.type) {
                    filters.type = this.filters.type
                }
                if (this.filters.channel) {
                    filters.channel = this.filters.channel
                }
                if (this.filters.timestampStart) {
                    filters.timestampStart = this.filters.timestampStart
                }
                if (this.filters.timestampEnd) {
                    filters.timestampEnd = this.filters.timestampEnd
                }
                return filters
            }
        },
        watch: {
            'filters.type': {
                handler(newVal) {
                    if (newVal === 'TRANSACTIONAL') {
                        this.filters.campaignId = ''
                        this.filters.campaignName = ''
                    }
                }
            }
        },
        created() {
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : this.page
            this.initializeHeaders()
            this.fetchAllErrors()
        },
        methods: {
            initializeHeaders() {
                const newHeaders = [
                    { text: 'Time', value: 'timestamp' },
                    { text: 'Campaign Id', value: 'campaignId' },
                    { text: 'Campaign Name', value: 'campaignName' },
                    { text: 'Type', value: 'type' },
                    { text: 'Channel', value: 'channel' },
                    { text: 'ACTION', value: 'action' },
                    { text: 'File Name', value: 'filename' },
                    { text: 'Error', value: 'error' }
                ]
                this.commonHeaders = newHeaders
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllErrors()
            },
            clearFilters() {
                this.filters = {
                    campaignId: '',
                    campaignName: '',
                    type: null,
                    channel: null,
                    timestampStart: null,
                    timestampEnd: null
                }
                this.filterDateRange = []
                this.fetchAllErrors()
            },
            searchClick() {
                this.page = 1
                this.fetchAllErrors()
            },
            fetchAllErrors() {
                this.isFetchingTrans = true
                errorService.getFilteredErrors(this.filtersToApply, this.page, this.size).then(resp => {
                    this.totalPages = resp.data.totalPages
                    this.items = resp.data.errors
                        .map((item, index) => ({
                            ...item,
                            timestamp: item.timestamp && dateTimeUtils.getFormattedGreekHumanizedDate(item.timestamp, true),
                            index: index + (this.page - 1) * this.size + 1
                        }))

                    this.totalItems = resp.data.totalElements
                }).finally(() => {
                    this.isFetchingTrans = false
                })
            },
            clearDateRange() {
                this.filterDateRange = []
            },
            setDateRange() {
                if (this.filterDateRange[0]) {
                    this.filters.timestampStart = dateTimeUtils.getFormattedDateForSubmit(this.filterDateRange[0])
                } else {
                    this.filters.timestampStart = null
                }

                if (this.filterDateRange[1]) {
                    this.filters.timestampEnd = dateTimeUtils.getFormattedDateForSubmit(this.filterDateRange[1])
                } else {
                    this.filters.timestampEnd = null
                }
            }
        }
    }
</script>

<style scoped lang="scss">
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
}

.filters {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;

    legend {
        font-weight: 900;
    }
}

.form-wrapper label {
    font-size: 14px;
}

@media (max-width: 992px) {
    .header {
        flex-direction: column;
    }

    .filters {
        flex-direction: column;
        align-items: center;
        justify-content: center;

        *:not(button,legend) {
            width: 100%;
        }
    }
}
</style>
